import type { DiffChange } from "@gaurussel/tiptap-diff-utility";

export interface ChangeStop {
	pos: number;
	isDeleted: boolean;
	order: number;
}

/** Must follow the rendering rules (one stop per drawn bar or seam), or the counter disagrees with the screen. */
const changeStops = (changes: DiffChange[]): ChangeStop[] => {
	const seams = new Set<number>();
	const stops: ChangeStop[] = [];

	changes.forEach((change) => {
		if (change.type === "deleted") {
			if (change.nodeA?.type.name === "tab") return;
			if (change.from === undefined || seams.has(change.from)) return;
			seams.add(change.from);
			stops.push({ pos: change.from, isDeleted: true, order: change.from });
			return;
		}

		if (change.posB === undefined) return;
		stops.push({ pos: change.posB, isDeleted: false, order: change.posB });
	});

	return stops.sort((left, right) => left.order - right.order);
};

export const nextStopIndex = (total: number, current: number | null, direction: 1 | -1): number | null => {
	if (total <= 0) return null;
	if (current === null) return direction === 1 ? 0 : total - 1;
	return (current + direction + total) % total;
};

export default changeStops;
